import styled from "styled-components";

export const IdentityVerificationContainer = styled.div`
  section {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    align-items: flex-start;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 24px;
    }
  }

  .heading-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .documents-list {
    flex: 1;
    width: 100%;
  }

  h2 {
    margin-bottom: 0px !important;
    color: #414651;
    font-size: 14px;
    font-weight: 500;
    font-family: "Geist", sans-serif;
  }

  span {
    color: #535862;
    font-size: 14px;
    font-weight: 400;
    font-family: "Geist", sans-serif;
  }

  button.button-small {
    &:disabled {
      border: 1px solid ${({ theme }) => theme.aside.icon.tertiary};
    }
  }

  @media (max-width: 768px) {
    .button-wrapper {
      flex: auto;
      width: 100%;
    }
    .button-small {
      width: 100%;
    }
  }
`;

export const VerifiedStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #079455;
  font-weight: 500;
  font-size: 14px;
`;

export const VerificationItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
`;

export const InfoSection = styled.div`
  strong {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    color: #344054;
  }
  span {
    font-size: 14px;
    color: #475467;
  }
`;

export const EmptyStateText = styled.div`
  margin-top: 16px;
  color: #475467;
  font-size: 14px;
`;
